import { toLonLat } from 'ol/proj';
import { setFloatingControlsVisible, closeSidebarOnMobile } from './CustomFunctions';
import { map } from './Map';

/* =========================
   نافذة المشاركة
   ========================= */
function showShareModal(url) {
  // احذف أي نافذة قديمة
  $('#shareModal').remove();

  const shareModal = $(`
    <div id="shareModal" class="coordinate-modal">
      <div class="coordinate-modal-content" style="max-width: 520px; width: min(92vw, 520px);">
        <div class="coordinate-modal-header">
          <h4><i class="fas fa-share-alt"></i> مشاركة الخريطة</h4>
          <button class="coordinate-modal-close" id="closeShareModal" aria-label="إغلاق">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="coordinate-modal-body">
          <!-- Success -->
          <div class="share-success-box">
            <div class="share-success-icon">
              <i class="fas fa-check"></i>
            </div>
            <h4>تم نسخ الرابط بنجاح!</h4>
            <p>يمكنك الآن مشاركة رابط الخريطة مع الآخرين.</p>
          </div>

          <!-- Link box -->
          <div class="share-link-box">
            <div class="share-link-header">
              <i class="fas fa-link"></i>
              <span>الرابط المنسوخ</span>
            </div>
            <div class="share-link-content">${url}</div>
          </div>

          <!-- Actions -->
          <div style="display:flex; gap:10px; justify-content:center; margin-top:16px;">
            <button id="copyAgainBtn" class="coordinate-btn" style="background: linear-gradient(135deg,#6f42c1 0%,#5a32a3 100%); color:#fff;">
              <i class="fas fa-copy"></i> نسخ مرة أخرى
            </button>
            <button id="closeShareBtn" class="coordinate-btn coordinate-btn-secondary">
              <i class="fas fa-times"></i> إغلاق
            </button>
          </div>
        </div>
      </div>
    </div>
  `);

  // الأنماط الآن في components.css

  $('body').append(shareModal);

  // أحداث
  $('#closeShareModal, #closeShareBtn').on('click', hideShareModal);
  $('#copyAgainBtn').on('click', function () {
    try {
      navigator.clipboard.writeText(url).then(() => {
        $(this).html('<i class="fas fa-check"></i> تم النسخ!');
        setTimeout(() => $(this).html('<i class="fas fa-copy"></i> نسخ مرة أخرى'), 1200);
      }).catch(() => { fallbackCopyTextToClipboard(url); });
    } catch { fallbackCopyTextToClipboard(url); }
  });

  // إغلاق عند الضغط خارج
  $('#shareModal').on('click', function (e) { if (e.target === this) hideShareModal(); });

  // ESC
  $(document).on('keydown.shareModal', (e) => { if (e.key === 'Escape') hideShareModal(); });
}

function hideShareModal() {
  const modal = $('#shareModal');
  if (!modal.length) return;
  modal.fadeOut(250, function () {
    $(this).remove();
    $(document).off('keydown.shareModal');
  });
}

/* =========================
   نسخ احتياطي (يدعم الجوال)
   ========================= */
function fallbackCopyTextToClipboard(text) {
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.style.position = 'fixed';
  ta.style.top = '0';
  ta.style.left = '0';
  ta.style.opacity = '0';
  document.body.appendChild(ta);
  ta.focus(); ta.select();
  try { document.execCommand('copy'); }
  catch { showErrorModal('فشل في نسخ الرابط. انسخه يدويًا.'); }
  document.body.removeChild(ta);
}

/* =========================
   زر المشاركة
   ========================= */
// يفترض وجود زر بالصفحة يحمل id="shareBtn"
$('#shareBtn').off('click').on('click', function () {
  const center = map.getView().getCenter();
  const zoom = map.getView().getZoom();
  const url = `${location.origin}${location.pathname}?center=${center[0]},${center[1]}&zoom=${zoom}`;

  // Close sidebar on mobile to show the modal properly
  closeSidebarOnMobile();

  // نسخ + إظهار نافذة
  try {
    navigator.clipboard.writeText(url).then(() => { showShareModal(url); })
      .catch(() => { fallbackCopyTextToClipboard(url); showShareModal(url); });
  } catch {
    fallbackCopyTextToClipboard(url);
    showShareModal(url);
  }
});

/* =========================
   استرجاع الحالة من الرابط
   ========================= */
(function restoreFromUrl() {
  const params = new URLSearchParams(location.search);
  const centerParam = params.get('center');
  const zoomParam = params.get('zoom');
  if (centerParam && zoomParam) {
    const coords = centerParam.split(',').map(Number);
    if (Array.isArray(coords) && coords.length === 2 && !coords.some(isNaN)) {
      map.getView().setCenter(coords);
      map.getView().setZoom(Number(zoomParam));

      // reception toast logic
      const toast = $(`
        <div class="reception-toast">
          <div class="reception-icon"><i class="fas fa-map-marker-alt"></i></div>
          <div class="reception-content">
            <h4>تم استلام الموقع</h4>
            <p>تم الانتقال إلى الإحداثيات المشتركة.</p>
          </div>
          <button class="reception-close"><i class="fas fa-times"></i></button>
        </div>
      `);

      $('body').append(toast);

      requestAnimationFrame(() => toast.addClass('show'));

      // Close events
      const closeToast = () => {
        toast.removeClass('show');
        setTimeout(() => toast.remove(), 400);
      };

      toast.find('.reception-close').on('click', closeToast);
      setTimeout(closeToast, 4000);
    }
  }
})();

/* =========================
   نافذة خطأ بسيطة (اختيارية)
   ========================= */
function showErrorModal(message) {
  $('#errorModal').remove();
  const errorModal = $(`
    <div id="errorModal" class="coordinate-modal">
      <div class="coordinate-modal-content" style="max-width: 400px; text-align: center;">
        <div class="coordinate-modal-body">
          <div style="color: var(--primary); font-size: 3rem; margin-bottom: 16px;">
            <i class="fas fa-exclamation-triangle"></i>
          </div>
          <h4 style="color: var(--primary); margin: 0 0 12px 0; font-weight: 700;">خطأ!</h4>
          <p style="color: var(--text-secondary); margin: 0 0 20px 0; line-height: 1.6;">${message}</p>
          <button id="errOk" class="coordinate-btn coordinate-btn-primary">حسناً</button>
        </div>
      </div>
    </div>
  `);
  $('body').append(errorModal);
  $('#errOk, #errorModal').on('click', function (e) {
    if (e.target.id === 'errOk' || e.target.id === 'errorModal') {
      $('#errorModal').fadeOut(200, function () { $(this).remove(); });
    }
  });
}
